import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import en from './en.json';
import pl from './pl.json';

void i18n.use(initReactI18next).init({
  resources: {
    pl: { translation: pl },
    en: { translation: en },
  },
  lng: 'pl',
  fallbackLng: 'pl',
  interpolation: {
    escapeValue: false, // React handles XSS
  },
});

export default i18n;
